// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"507":"29780968","797":"29780968","973":"29780968"}[chunkId] + ".chunk.css";
};